import { render, staticRenderFns } from "./LiveDeptSelect.vue?vue&type=template&id=63dc3be9&scoped=true"
import script from "./LiveDeptSelect.vue?vue&type=script&lang=js"
export * from "./LiveDeptSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dc3be9",
  null
  
)

export default component.exports